<template>
  <div class="player-video">
    <div class="video">
      <youtube
        v-if="youtubeId"
        ref="youtube"
        :player-vars="playerVars"
        :video-id="youtubeId"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlayerVideo',

  props: {
    youtubeId: { type: String, default: null },
  },

  data() {
    return {
      playerVars: {
        autoplay: 1,
        controls: 1,
        rel: 0,
        modestbranding: 1,
        showinfo: 0,
      },
    };
  },
};
</script>

<style lang="stylus" scoped>
.video {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  margin-left: auto; margin-right: @margin-left;
}
</style>

<style lang="stylus">
iframe {
  aspect-ratio: 16/9;
  width: 100%;
  height: auto;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  border: 1px solid $cl-yellow;
  border-radius: 6px;
  overflow: hidden;

  +mobile() {
    @media (orientation: portrait) {
      height: auto;
    }
  }
}
</style>
